var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-viewer" }, [
    _c("header", { staticClass: "form-viewer-toolbar" }, [
      _c("div", { staticClass: "form-identity" }, [
        _c(
          "span",
          { staticClass: "form-mark", attrs: { "aria-hidden": "true" } },
          [_c("portal-icon", { attrs: { name: "file-check", size: 19 } })],
          1
        ),
        _c("div", { staticClass: "form-title" }, [
          _c("h1", [_vm._v(_vm._s(_vm.submission.formName))]),
          _vm.submission.submittedAt
            ? _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.DateTime.fromISO(
                        _vm.submission.submittedAt
                      ).toLocaleString(_vm.DateTime.DATETIME_MED)
                    ) +
                    " "
                )
              ])
            : _vm._e()
        ])
      ]),
      _c(
        "button",
        {
          staticClass: "round-action",
          attrs: {
            type: "button",
            "aria-label": _vm.$t("global.close"),
            title: _vm.$t("global.close")
          },
          on: { click: _vm.handleClose }
        },
        [_c("portal-icon", { attrs: { name: "x", size: 19 } })],
        1
      )
    ]),
    _c("div", { staticClass: "form-frame-shell" }, [
      !_vm.isReady
        ? _c(
            "div",
            { staticClass: "form-frame-loading" },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: 38,
                  width: 3,
                  color: "primary"
                }
              })
            ],
            1
          )
        : _c("main", { staticClass: "form-result-body show-scrollbar" }, [
            _vm.hasContactDetails
              ? _c("section", { staticClass: "contact-card" }, [
                  _vm.contactName
                    ? _c("div", { staticClass: "contact-row" }, [
                        _c(
                          "span",
                          { staticClass: "detail-icon" },
                          [
                            _c("portal-icon", {
                              attrs: { name: "user-round", size: 17 }
                            })
                          ],
                          1
                        ),
                        _c("strong", [_vm._v(_vm._s(_vm.contactName))])
                      ])
                    : _vm._e(),
                  _vm.formData.email
                    ? _c(
                        "a",
                        {
                          staticClass: "contact-row",
                          attrs: { href: "mailto:" + _vm.formData.email }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "detail-icon" },
                            [
                              _c("portal-icon", {
                                attrs: { name: "mail", size: 17 }
                              })
                            ],
                            1
                          ),
                          _c("strong", [_vm._v(_vm._s(_vm.formData.email))])
                        ]
                      )
                    : _vm._e(),
                  _vm.formData.phone
                    ? _c(
                        "a",
                        {
                          staticClass: "contact-row",
                          attrs: { href: "tel:" + _vm.formData.phone }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "detail-icon" },
                            [
                              _c("portal-icon", {
                                attrs: { name: "phone", size: 17 }
                              })
                            ],
                            1
                          ),
                          _c("strong", [_vm._v(_vm._s(_vm.formData.phone))])
                        ]
                      )
                    : _vm._e(),
                  _vm.formData.businessName
                    ? _c("div", { staticClass: "contact-row" }, [
                        _c(
                          "span",
                          { staticClass: "detail-icon" },
                          [
                            _c("portal-icon", {
                              attrs: { name: "folder", size: 17 }
                            })
                          ],
                          1
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.formData.businessName))
                        ])
                      ])
                    : _vm._e(),
                  _vm.formattedAddress
                    ? _c("div", { staticClass: "contact-row" }, [
                        _c(
                          "span",
                          { staticClass: "detail-icon" },
                          [
                            _c("portal-icon", {
                              attrs: { name: "map-pin", size: 17 }
                            })
                          ],
                          1
                        ),
                        _c("strong", [_vm._v(_vm._s(_vm.formattedAddress))])
                      ])
                    : _vm._e(),
                  _vm.formData.website
                    ? _c(
                        "a",
                        {
                          staticClass: "contact-row",
                          attrs: {
                            href: _vm.websiteUrl,
                            target: "_blank",
                            rel: "noopener"
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "detail-icon" },
                            [
                              _c("portal-icon", {
                                attrs: { name: "external-link", size: 17 }
                              })
                            ],
                            1
                          ),
                          _c("strong", [_vm._v(_vm._s(_vm.formData.website))])
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.answers.length
              ? _c(
                  "section",
                  { staticClass: "answer-grid" },
                  _vm._l(_vm.answers, function(answer, index) {
                    return _c(
                      "article",
                      { key: answer.id || index, staticClass: "answer-card" },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.questionText(answer.question)))
                        ]),
                        _c("p", [
                          _vm._v(_vm._s(_vm.formatAnswer(answer.answer)))
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.files.length
              ? _c(
                  "section",
                  { staticClass: "file-list" },
                  _vm._l(_vm.files, function(file) {
                    return _c(
                      "a",
                      {
                        key: file.id || file.fileName,
                        staticClass: "file-row",
                        attrs: {
                          href: file.signedUrl,
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "detail-icon" },
                          [
                            _c("portal-icon", {
                              attrs: { name: "paperclip", size: 17 }
                            })
                          ],
                          1
                        ),
                        _c("strong", [_vm._v(_vm._s(file.fileName))]),
                        _c("portal-icon", {
                          attrs: { name: "external-link", size: 15 }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }